import React from 'react';
import PropTypes from 'prop-types';
import jump from 'jump.js';
import { withRouter } from 'react-router';

class ScrollableAnchor extends React.Component {
    static propTypes = {
        duration: PropTypes.number,
        offset: PropTypes.number,
        callback: PropTypes.func,
        a11y: PropTypes.bool
    };

    static defaultProps = {
        duration: 500,
        offset: 0,
        callback: undefined,
        a11y: false
    };
    checkTop=()=>{
      setTimeout(()=>{
        const element = document.querySelector(this.props.location.hash);
        if (element) {
          if(element.offsetTop !== 0){
            jump(element, {
              duration: 0,
              offset: -100,
              callback: this.props.callback,
              a11y: this.props.a11y
            });
          } else this.checkTop()
        }
      }, 15)
    }
    componentDidMount() {
      try{
        const id = this.props.location.hash.split('#');
        if(id[1] && this.props.id === id[1]) this.checkTop();
      }catch(e){
        
      }
    }
    componentDidUpdate(prevProps) {
      if (this.props.location.hash !== prevProps.location.hash) this.checkTop()  
  }
    render() {
        return <div id={this.props.id} style={this.props.style}>{this.props.children}</div>
    }
}
export default withRouter(ScrollableAnchor);